// src/pages/Servicios1.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  Timestamp
} from 'firebase/firestore';

const Servicios1 = () => {
  const [clientes, setClientes] = useState([]);
  const [clienteId, setClienteId] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [precio, setPrecio] = useState('');
  const [servicios, setServicios] = useState([]);
  const [filtroCliente, setFiltroCliente] = useState('');
  const [metodoPago, setMetodoPago] = useState('efectivo');
  const [moneda, setMoneda] = useState('USD');
  const [tasaBCV, setTasaBCV] = useState(0);

  const clientesRef = collection(db, 'clientes');
  const serviciosRef = collection(db, 'servicios');

  // Obtener clientes y servicios
  const obtenerClientes = async () => {
    const data = await getDocs(clientesRef);
    setClientes(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  };

  const obtenerServicios = async () => {
    const data = await getDocs(serviciosRef);
    setServicios(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  };

  // Obtener tasa BCV
  const obtenerTasaBCV = async () => {
    try {
      const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
      const data = await res.json();
      const tasa = data.rates && data.rates.VES;
      setTasaBCV(tasa || 36);
    } catch (error) {
      setTasaBCV(36);
    }
  };

  useEffect(() => {
    obtenerClientes();
    obtenerServicios();
    obtenerTasaBCV();
  }, []);

  // Manejar el formulario para crear servicio
  const agregarServicio = async (e) => {
    e.preventDefault();
    if (!clienteId || !descripcion || !precio) return alert("Completa todos los campos");

    // Guardar como servicio pendiente en localStorage para enviar a Venta
    const servicioPendiente = {
      clienteId,
      nombre: descripcion,
      descripcion,
      precio: parseFloat(precio),
      cantidad: 1,
      fecha: Timestamp.now(),
      metodoPago,
      moneda,
      montoBS: moneda === 'BS' ? parseFloat(precio) : parseFloat(precio) * tasaBCV,
      montoUSD: moneda === 'USD' ? parseFloat(precio) : parseFloat(precio) / tasaBCV,
      negocio: parseFloat(precio) / 2,
      mecanico: parseFloat(precio) / 2,
      estado: 'pendiente' // Estado pendiente por default
    };

    // Guardar el servicio en Firestore como "pendiente"
    await addDoc(serviciosRef, {
      ...servicioPendiente,
      estado: 'pendiente'
    });

    // Guardar en localStorage para que Venta.jsx lo recoja
    localStorage.setItem("servicio_pendiente", JSON.stringify(servicioPendiente));
    // Redirigir a la página de venta (asegúrate de usar useNavigate si usas react-router-dom v6+)
    window.location.href = '/venta';
  };

  // Eliminar un servicio
  const eliminarServicio = async (id) => {
    await deleteDoc(doc(db, 'servicios', id));
    obtenerServicios();
  };

  // Buscar nombre del cliente
  const buscarNombreCliente = (id) => {
    const cliente = clientes.find(c => c.id === id);
    return cliente ? cliente.nombre : 'Desconocido';
  };

  // Formatear fecha
  const formatearFecha = (fecha) => {
    if (fecha && typeof fecha.toDate === 'function') {
      return fecha.toDate().toLocaleDateString();
    }
    return 'Fecha no disponible';
  };

  // Filtro por cliente
  const serviciosFiltrados = filtroCliente
    ? servicios.filter(s => s.clienteId === filtroCliente)
    : servicios;

  return (
    <div className="servicios-container">
      <h2>Servicios Realizados</h2>

      <form onSubmit={agregarServicio} className="servicios-form">
        <select
          value={clienteId}
          onChange={(e) => setClienteId(e.target.value)}
        >
          <option value="">Seleccionar cliente</option>
          {clientes.map((cliente) => (
            <option key={cliente.id} value={cliente.id}>
              {cliente.nombre} - {cliente.cedula}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Descripción del servicio"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
        />

        <input
          type="number"
          placeholder="Precio"
          value={precio}
          onChange={(e) => setPrecio(e.target.value)}
        />

        <select value={metodoPago} onChange={(e) => setMetodoPago(e.target.value)}>
          <option value="efectivo">Efectivo</option>
          <option value="tarjeta">Tarjeta</option>
        </select>

        <select value={moneda} onChange={(e) => setMoneda(e.target.value)}>
          <option value="USD">$ USD</option>
          <option value="BS">Bs (BCV)</option>
        </select>

        <button type="submit">Enviar a Venta</button>
      </form>

      <div className="filtro-servicios">
        <label>Filtrar por cliente: </label>
        <select
          value={filtroCliente}
          onChange={(e) => setFiltroCliente(e.target.value)}
        >
          <option value="">Todos</option>
          {clientes.map((cliente) => (
            <option key={cliente.id} value={cliente.id}>{cliente.nombre}</option>
          ))}
        </select>
      </div>

      <ul>
        {serviciosFiltrados
          .sort((a, b) => (b.fecha?.seconds || 0) - (a.fecha?.seconds || 0))
          .map((serv) => (
          <li key={serv.id} className="servicio-item">
            <strong>Cliente:</strong> {buscarNombreCliente(serv.clienteId)}<br />
            <span><strong>Descripción:</strong> {serv.descripcion}</span><br />
            <span><strong>Precio:</strong> ${serv.precio?.toFixed(2) || '0.00'}</span><br />
            <span><strong>Método:</strong> {serv.metodoPago} | <strong>Moneda:</strong> {serv.moneda}</span><br />
            <span><strong>Negocio:</strong> ${serv.negocio?.toFixed(2) || '0.00'} | <strong>Mecánico:</strong> ${serv.mecanico?.toFixed(2) || '0.00'}</span><br />
            <span><strong>Fecha:</strong> {formatearFecha(serv.fecha)}</span><br />
            <span><strong>Estado:</strong> {serv.estado === 'pendiente' ? 'Pendiente por venta' : 'Venta confirmada'}</span><br />
            <button
              onClick={() => eliminarServicio(serv.id)}
              style={{ marginTop: '8px', backgroundColor: '#cc0000', color: 'white', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'pointer' }}
            >
              Eliminar servicio
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Servicios1;
